import React, { useState } from 'react';
import styled from 'styled-components';
import { Box, Divider, FormControlLabel, FormGroup } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { Checkbox } from 'common/components/Checkbox';
import { DetailBox } from 'common/components/DetailBox';
import { Button } from 'common/components/buttons/Button';
import { SectionTitle } from 'common/components/SectionTitle';
import { IBudgetType } from 'graphql/types';

interface IProps {
    budgets?: Pick<IBudgetType, 'id' | 'name'>[];
    className?: string;
    onSubmit(budgets: string[]): void;
}

const BaseInvitationForm: React.FC<IProps> = ({
    budgets,
    className,
    onSubmit,
}) => {
    const { t } = useTranslation();
    const [selectedBudgets, setSelectedBudgets] = useState<string[]>([]);

    const handleBudgetClick = (id: string) => {
        if (selectedBudgets.includes(id)) {
            setSelectedBudgets(
                selectedBudgets.filter((budget) => budget !== id)
            );
        } else {
            setSelectedBudgets([...selectedBudgets, id]);
        }
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!selectedBudgets.length) return;

        onSubmit(selectedBudgets);
    };

    return (
        <DetailBox
            className={className}
            description={t('employee.detail.newInviteDescription')}
            loading={!budgets}
            title={t('employee.detail.create')}
        >
            <form onSubmit={handleSubmit}>
                <Box mb={6}>
                    <SectionTitle>
                        {t('employee.detail.chooseBudget')}
                    </SectionTitle>
                    <FormGroup>
                        {budgets?.map((budget) => (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={() =>
                                            handleBudgetClick(budget.id)
                                        }
                                    />
                                }
                                key={budget.id}
                                label={budget.name}
                            />
                        ))}
                    </FormGroup>
                </Box>
                <Divider />
                <Box display="flex" justifyContent="flex-end" mt={3}>
                    <Button
                        small
                        disabled={!selectedBudgets.length}
                        type="submit"
                    >
                        {t('employee.detail.sendInvite')}
                    </Button>
                </Box>
            </form>
        </DetailBox>
    );
};

export const InvitationForm = styled(BaseInvitationForm)``;
